<template>
    <div class="ah-page payment-calendar-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>收支日曆</h1>
                    </div>
                    <div class="actions">
                        <el-date-picker
                            v-model="selectedDate"
                            type="month"
                            format="yyyy 年 MM 月"
                            placeholder="選擇月"
                            style="margin-right: 5px; font-size: 11pt; font-weight: bold;"
                            :clearable="false"
                            :editable="false"
                        >
                        </el-date-picker>
                        <el-button @click="fetchData()" icon="el-icon-refresh"></el-button>
                    </div>
                </div>
            </div>
            <div class="row main-color">
                <div class="ah-container">
                    <div class="top-month-picker"></div>
                    <SummaryBoard :year="year" :month="month" :summary="summary" />
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div style="position: relative">
                    <div style="position: absolute; right: 220px; top: 12px">
                        <el-date-picker v-model="selectedDate" type="month" placeholder="選擇月份" size="mini" style="width: 125px"> </el-date-picker>
                    </div>
                </div>
                <el-calendar v-model="selectedDate" class="calendar" v-loading="isLoading">
                    <template slot="dateCell" slot-scope="{ date, data }" v-if="isCurrMonthDate(date)">
                        <div class="date-number">
                            <span class="num">{{ parseInt(data.day.split("-")[2]) }}</span>
                            <span class="lunar-date">{{ getLunarDate(date) }}</span>
                        </div>
                        <div class="date-items">
                            <div class="item invoice" @click="handelItemClick(data.day, 'income')" @keydown="() => {}" v-if="getIncomeItemsByCny(data.day).length > 0">
                                <div v-for="item in getIncomeItemsByCny(data.day)" :key="item.sno">
                                    <span class="count"
                                        ><span>{{ item.count }}</span></span
                                    >
                                    <span class="cny">{{ cnyName[item.cny] }}</span>
                                    <span class="amt"> <Money :v="item.amount"/></span>
                                </div>
                            </div>
                            <div class="item payout" @click="handelItemClick(data.day, 'payout')" @keydown="() => {}">
                                <div v-for="item in getPayoutItemsByCny(data.day)" :key="item.sno">
                                    <span class="count"
                                        ><span>{{ item.count }}</span></span
                                    >
                                    <span class="cny">{{ cnyName[item.cny] }}</span>
                                    <span class="amt"> <Money :v="item.amount"/></span>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-calendar>
            </div>
        </div>
        <DetailDialog :visible="detailDialog.visible" :type="detailDialog.type" :date="detailDialog.date" :items="detailDialog.items" @refresh="fetchData" @close="handleDetailDialogClose" />
    </div>
</template>
<script>
import _ from 'lodash';
import chineseLunar from 'chinese-lunar'; // 使用參考https://github.com/wvv8oo/lunar
import { cnyName } from '@/assets/commonData/options';
import dayjs from 'dayjs';
import DetailDialog from './DetailDialog.vue';
import SummaryBoard from './SummaryBoard.vue';

export default {
    components: { DetailDialog, SummaryBoard },
    data() {
        return {
            isLoading: false,
            cnyName,
            selectedDate: new Date(),
            detailDialog: {
                visible: false,
                date: '', // 2020-12-25
                type: '', // income | payout
                items: {
                    invoice: [],
                    refund: [],
                    payout: [],
                    salary: [],
                    vIn: [],
                    vOut: [],
                },
            },
            items: {
                invoice: [],
                refund: [],
                payout: [],
                salary: [],
                vIn: [],
                vOut: [],
            },
            summary: {
                invoiceTotal: 0,
                vInTotal: 0,
                paymentTotal: 0,
                salaryTotal: 0,
                vOutTotal: 0,

                invoiceByCny: [],
                vInByCny: [],
                paymentsByCny: [],
                salaryByCny: [],
                vOutByCny: [],
            },
        };
    },
    watch: {
        selectedDate(newValue, oldValue) {
            if (oldValue.getMonth() !== newValue.getMonth()) {
                this.fetchData();
            }
        },
    },
    mounted() {
        this.fetchData();
        const buttons = document.querySelectorAll('.el-button--plain.el-button--mini > span');

        buttons[0].innerHTML = '上個月';
        buttons[1].innerHTML = '今天';
        buttons[2].innerHTML = '下個月';
    },
    computed: {
        year() {
            return this.selectedDate.getFullYear();
        },
        month() {
            return this.selectedDate.getMonth() + 1;
        },
        cnyOptions() {
            return this.$store.getters['cny/cnyOptions'];
        },
    },
    methods: {
        isCurrMonthDate(date) {
            const inputYearMonth = dayjs(date).format('YYYY-MM');
            const queryYearMonth = dayjs(this.selectedDate).format('YYYY-MM');
            return inputYearMonth === queryYearMonth;
        },
        getActiveDate(item) {
            // 有實際付款日期
            if (item.actuallyDate) {
                return item.actuallyDate;
            }
            // 用預計付款日期
            return item.pdat;
        },
        handleDetailDialogClose() {
            this.detailDialog.visible = false;
        },
        handelItemClick(dateString, type) {
            this.detailDialog.visible = true;
            this.detailDialog.date = dateString;
            this.detailDialog.type = type;
            this.detailDialog.items = this.getItemsByDate(dateString);
        },
        getItemsByDate(date) {
            if (this.items) {
                return {
                    invoice: this.getInvoiceItemsByDate(date),
                    refund: this.getRefundItemsByDate(date),
                    payout: this.getPaymentItemsByDate(date),
                    salary: this.getSalaryItemsByDate(date),
                    vIn: this.getVariableInItemsByDate(date),
                    vOut: this.getVariableOutItemsByDate(date),
                };
            }
            return {
                invoice: [],
                refund: [],
                payout: [],
                vIn: [],
                vOut: [],
            };
        },
        getLunarDate(date) {
            return chineseLunar.format(chineseLunar.solarToLunar(new Date(date)), 'D');
        },
        getWeekday(date) {
            return dayjs().day(date);
        },
        fetchData() {
            this.isLoading = true;

            this.$api({
                url: '/FinancialMonthlyCalendarPage/GetMonthlyEvents',
                params: {
                    Year: this.selectedDate.getFullYear(),
                    Month: this.selectedDate.getMonth() + 1,
                },
                method: 'GET',
            })
                .then((resp) => {
                    // 將請款、發票、財務收支、薪資轉為 items
                    // (發票＆請款 過濾出當月的交易)
                    this.items = {
                        invoice: resp.data.invoiceItems.filter((item) => {
                            const itemDate = this.getActiveDate(item);
                            return this.isCurrMonthDate(itemDate);
                        }),
                        refund: resp.data.refundItems.filter((item) => {
                            const itemDate = this.getActiveDate(item);
                            return this.isCurrMonthDate(itemDate);
                        }),
                        payout: resp.data.payoutItems.filter((item) => {
                            const itemDate = this.getActiveDate(item);
                            return this.isCurrMonthDate(itemDate);
                        }),
                        salary: resp.data.salaryItems.filter((item) => {
                            const itemDate = this.getActiveDate(item);
                            return this.isCurrMonthDate(itemDate);
                        }),
                        vIn: _.chain(resp.data.vInItems)
                            .filter((o) => o.froM_UNT !== 'REPAYMENT')
                            .filter((item) => {
                                const itemDate = this.getActiveDate(item);
                                return this.isCurrMonthDate(itemDate);
                            })
                            .value(),
                        vOut: _.chain(resp.data.vOutItems)
                            .filter((o) => o.froM_UNT !== 'DRAWDOWN')
                            .filter((item) => {
                                const itemDate = this.getActiveDate(item);
                                return this.isCurrMonthDate(itemDate);
                            })
                            .value(),
                    };

                    // 更新統計資訊
                    if (this.cnyOptions.length > 0) {
                        this.updateSummary(resp.data.statisticalList);
                    } else {
                        this.$store.dispatch('cny/updateCnyOptions').then(() => {
                            this.updateSummary(resp.data.statisticalList);
                        });
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getIncomeItemsByCny(date) {
            const result = [];

            // 用日期取各種支出
            const todayInvoices = this.getInvoiceItemsByDate(date);
            const todayVIns = this.getVariableInItemsByDate(date);

            // 彙整
            const todayAll = todayInvoices.concat(todayVIns);

            // 分幣別
            const cnys = [...new Set(todayAll.map((x) => x.cny))];
            if (cnys) {
                cnys.forEach((cny) => {
                    const thisCnyItems = todayAll.filter((item) => item.cny === cny);

                    result.push({
                        count: thisCnyItems.length,
                        cny,
                        amount: thisCnyItems.reduce((accumulator, currentValue) => accumulator + currentValue.amt, 0),
                    });
                });
            }
            return result;
        },
        // 取得特定日期的所有支出
        getPayoutItemsByCny(date) {
            const result = [];

            // 用日期取各種支出
            const todayPayouts = this.getPaymentItemsByDate(date);
            const todayVOuts = this.getVariableOutItemsByDate(date);
            const todaySalary = this.getSalaryItemsByDate(date);
            const todayRefund = this.getRefundItemsByDate(date);

            // 彙整
            const todayAll = todayPayouts.concat(todayVOuts, todaySalary, todayRefund);

            // 分幣別
            const cnys = [...new Set(todayAll.map((x) => x.cny))];
            if (cnys) {
                cnys.forEach((cny) => {
                    const thisCnyItems = todayAll.filter((item) => item.cny === cny);

                    result.push({
                        count: thisCnyItems.length,
                        cny,
                        amount: thisCnyItems.reduce((accumulator, currentValue) => accumulator + currentValue.amt, 0),
                    });
                });
            }
            return result;
        },
        // 用日期取得請款單
        getPaymentItemsByDate(date) {
            return this.items.payout.filter((item) => {
                const itemDate = this.getActiveDate(item);
                return dayjs(itemDate).isSame(dayjs(date), 'day');
            });
        },
        // 用日期取得發票
        getInvoiceItemsByDate(date) {
            return this.items.invoice.filter((item) => {
                const itemDate = this.getActiveDate(item);
                return dayjs(itemDate).isSame(dayjs(date), 'day');
            });
        },
        // 用日期取得發票
        getRefundItemsByDate(date) {
            return this.items.refund.filter((item) => {
                const itemDate = this.getActiveDate(item);
                return dayjs(itemDate).isSame(dayjs(date), 'day');
            });
        },
        // 用日期取得財務支出
        getVariableOutItemsByDate(date) {
            return this.items.vOut.filter((x) => date === this.$options.filters.dateFormater(x.pdat, 'YYYY-MM-dd'));
        },
        // 用日期取得財務收入
        getVariableInItemsByDate(date) {
            return this.items.vIn.filter((x) => date === this.$options.filters.dateFormater(x.pdat, 'YYYY-MM-dd'));
        },
        // 用日期取得薪資支出
        getSalaryItemsByDate(date) {
            return this.items.salary.filter((x) => date === this.$options.filters.dateFormater(x.actuallyDate, 'YYYY-MM-dd'));
        },

        updateSummary(statisticalList) {
            // ========== 收入 ==========
            // 發票應收帳款（含稅）
            const invoiceIncomeByCny = _.cloneDeep(this.cnyOptions);
            this.items.invoice.forEach((item) => {
                const c = invoiceIncomeByCny.find((x) => x.cny === item.cny);
                if (!c.amt) {
                    c.amt = 0;
                    c.amtTwd = 0;
                }
                c.amt += item.amt;
                c.amtTwd += item.amt * item.rat;
            });
            const invoiceRefundByCny = _.cloneDeep(this.cnyOptions);
            this.items.refund.forEach((item) => {
                const c = invoiceRefundByCny.find((x) => x.cny === item.cny);
                if (!c.amt) {
                    c.amt = 0;
                    c.amtTwd = 0;
                }
                c.amt += -item.amt;
                c.amtTwd += item.amt * item.rat;
            });
            this.summary.invoiceByCny = [
                {
                    label: '入帳',
                    data: invoiceIncomeByCny,
                },
                {
                    label: '退款',
                    data: invoiceRefundByCny,
                },
            ];
            this.summary.invoiceTotal = _.sumBy(this.items.invoice, (o) => o.amt * o.rat) - _.sumBy(this.items.refund, (o) => o.amt * o.rat);

            // 財務收入
            const vInRepaymentByCny = _.cloneDeep(this.cnyOptions);
            const vInOtherByCny = _.cloneDeep(this.cnyOptions);
            _.chain(this.items.vIn)
                .filter((o) => o.froM_UNT !== 'DRAWDOWN')
                .value()
                .forEach((item) => {
                    const c = vInOtherByCny.find((x) => x.cny === item.cny);
                    if (!c.amt) {
                        c.amt = 0;
                        c.amtTwd = 0;
                    }
                    c.amt += item.amt;
                    c.amtTwd += item.amt * item.rat;
                });

            _.chain(this.items.vIn)
                .filter((o) => o.froM_UNT === 'DRAWDOWN')
                .value()
                .forEach((item) => {
                    const c = vInRepaymentByCny.find((x) => x.cny === item.cny);
                    if (!c.amt) {
                        c.amt = 0;
                        c.amtTwd = 0;
                    }
                    c.amt += item.amt;
                    c.amtTwd += item.amt * item.rat;
                });

            this.summary.vInByCny = [
                {
                    label: '借款管理 - 動撥',
                    data: _.chain(this.cnyOptions)
                        .cloneDeep()
                        .map((o) => ({
                            cny: o.cny,
                            amt: _.find(vInRepaymentByCny, ['cny', o.cny]).amt,
                            amtTwd: _.find(vInRepaymentByCny, ['cny', o.cny]).amtTwd,
                        }))
                        .value(),
                },
                {
                    label: '其他財務、資產收入',
                    data: _.chain(this.cnyOptions)
                        .cloneDeep()
                        .map((o) => ({
                            cny: o.cny,
                            amt: _.find(vInOtherByCny, ['cny', o.cny]).amt,
                            amtTwd: _.find(vInOtherByCny, ['cny', o.cny]).amtTwd,
                        }))
                        .value(),
                },
            ];
            this.summary.vInTotal = _.sumBy(this.items.vIn, (o) => o.amt * o.rat);

            // ========== 支出 ==========
            const SUM_LIST = _.find(statisticalList, ['cny', 'SUM']);
            // 請款單（實付）
            this.summary.paymentsByCny = _.chain(this.cnyOptions)
                .cloneDeep()
                .map((o) => ({
                    cny: o.cny,
                    amt: _.find(statisticalList, ['cny', o.cny]).payoutAmount,
                    amtTwd: _.find(statisticalList, ['cny', o.cny]).payoutAmountTwd,
                }))
                .value();
            this.summary.paymentTotal = SUM_LIST.payoutAmountTwd;

            // 人事薪資（實付）
            this.summary.salaryByCny = _.chain(this.cnyOptions)
                .cloneDeep()
                .map((o) => ({
                    cny: o.cny,
                    amt: _.find(statisticalList, ['cny', o.cny]).salaryAmount,
                    amtTwd: _.find(statisticalList, ['cny', o.cny]).salaryAmountTwd,
                }))
                .value();
            this.summary.salaryTotal = SUM_LIST.salaryAmountTwd;

            // 財務支出
            this.summary.vOutByCny = [
                {
                    label: '請款單（代扣）',
                    data: _.chain(this.cnyOptions)
                        .cloneDeep()
                        .map((o) => ({
                            cny: o.cny,
                            amt: _.find(statisticalList, ['cny', o.cny]).payoutWithheldAmount,
                            amtTwd: _.find(statisticalList, ['cny', o.cny]).payoutWithheldAmountTwd,
                        }))
                        .value(),
                },
                {
                    label: '人事費用（含代扣）',
                    data: _.chain(this.cnyOptions)
                        .cloneDeep()
                        .map((o) => ({
                            cny: o.cny,
                            amt: _.find(statisticalList, ['cny', o.cny]).salaryWithheldAmount,
                            amtTwd: _.find(statisticalList, ['cny', o.cny]).salaryWithheldAmountTwd,
                        }))
                        .value(),
                },
                {
                    label: '匯費',
                    data: _.chain(this.cnyOptions)
                        .cloneDeep()
                        .map((o) => ({
                            cny: o.cny,
                            amt: _.find(statisticalList, ['cny', o.cny]).remittanceAmount + _.find(statisticalList, ['cny', o.cny]).repaymentTotalAmount_REM_FEE,
                            amtTwd: _.find(statisticalList, ['cny', o.cny]).remittanceAmountTwd + _.find(statisticalList, ['cny', o.cny]).repaymentTotalAmount_REM_FEE_Twd,
                        }))
                        .value(),
                },
                {
                    label: '借款管理 - 還款本金',
                    data: _.chain(this.cnyOptions)
                        .cloneDeep()
                        .map((o) => ({
                            cny: o.cny,
                            amt: _.find(statisticalList, ['cny', o.cny]).repaymentTotalAmount_BNK_BACK,
                            amtTwd: _.find(statisticalList, ['cny', o.cny]).repaymentTotalAmount_BNK_BACK_Twd,
                        }))
                        .value(),
                },
                {
                    label: '借款管理 - 還款利息',
                    data: _.chain(this.cnyOptions)
                        .cloneDeep()
                        .map((o) => ({
                            cny: o.cny,
                            amt: _.find(statisticalList, ['cny', o.cny]).repaymentTotalAmount_BNK_INT,
                            amtTwd: _.find(statisticalList, ['cny', o.cny]).repaymentTotalAmount_BNK_INT_Twd,
                        }))
                        .value(),
                },
                {
                    label: '其他財務支出',
                    data: _.chain(this.cnyOptions)
                        .cloneDeep()
                        .map((o) => ({
                            cny: o.cny,
                            amt: _.find(statisticalList, ['cny', o.cny]).otherVOutAmount,
                            amtTwd: _.find(statisticalList, ['cny', o.cny]).otherVOutAmountTwd,
                        }))
                        .value(),
                },
            ];
            this.summary.vOutTotal = SUM_LIST.otherVOutAmountTwd
                + SUM_LIST.payoutWithheldAmountTwd
                + SUM_LIST.salaryWithheldAmountTwd
                + SUM_LIST.remittanceAmountTwd
                + SUM_LIST.repaymentTotalAmount_REM_FEE_Twd
                + SUM_LIST.repaymentTotalAmount_BNK_BACK_Twd
                + SUM_LIST.repaymentTotalAmount_BNK_INT_Twd;
        },

        getCnyRat(cny) {
            const cnyOption = this.cnyOptions.find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
    },
};
</script>
<style lang="scss">
.payment-calendar-page {
    .top-month-picker {
        margin-left: 20px;
        margin-bottom: 10px;
    }

    .calendar {
        .el-calendar-table {
            height: 1px; /* 為了讓 tb 裡的 hover 效果能上下填滿 */

            td {
                height: 100%; /* 為了讓 tb 裡的 hover 效果能上下填滿 */
            }
        }

        .el-calendar-day {
            padding: 0 0 10px 0;
            min-height: 130px;
            height: 100%;
        }
        .date-number {
            position: relative;
            font-size: 11pt;
            text-align: right;
            padding: 8px;
            height: 35px;

            .lunar-date {
                position: absolute;
                top: 8px;
                left: 8px;
                font-size: 10pt;
                color: #aaa;
            }
        }

        .date-items {
            min-height: 95px;
            padding: 0 8px;
            // overflow-y: auto;
        }

        .item {
            display: table;
            width: 100%;
            font-size: 9.5pt;
            padding: 0 10px 0 0;
            background-color: #ccc;
            border-radius: 5px;
            margin-bottom: 5px;
            color: #000;

            &.invoice {
                background-color: #b5ef98;
            }

            &.payout {
                background-color: #ffa6a6;
            }

            > div {
                display: table-row;
            }

            .count {
                display: table-cell;
                width: 23px;

                > span {
                    font-size: 8pt;
                    border-radius: 5px;
                    display: block;
                    height: 17px;
                    line-height: 17px;
                    text-align: center;
                    background-color: rgba(0, 0, 0, 0.5);
                    color: #fff;
                    margin: 4px 0 4px 4px;
                }
            }

            .cny {
                display: table-cell;
                font-size: 9pt;
                padding: 0 5px;
            }

            .amt {
                display: table-cell;
                text-align: right;
            }
        }

        .prev .item,
        .next .item {
            opacity: 0.65;
        }

        .is-today {
            color: #000;

            .date-number {
                .num {
                    /*
                    display: block;
                    color: #fff;
                    font-weight: bold;
                    width: 26px;
                    height: 26px;
                    line-height: 26px;
                    border-radius: 18px;
                    margin: 0 0 0 auto;
                    text-align: center;
                    background-color: #222;
                    */
                }
            }
        }
    }
}
</style>
